import { ElementType, HTMLAttributes, ReactNode } from "react";
import { classNames } from "@ct-react/core";
import * as stickable from "./stickable-box";
import * as scrollable from "./scrollable-items";
import * as twoCol from "./twoCol";
import * as cta from "./cta";
import "./index.scss";

type AnyWrapperProps<T = ReactNode | undefined> = HTMLAttributes<HTMLElement> & {
  as?: ElementType;
  children: T;
};

const toDomElement = <T = ReactNode | undefined>(...classes: string[]) => (
  {
    as: Tag = "div",
    className,
    children,
    ...others
  }: AnyWrapperProps<T>) => {
  const wrapperClasses = classNames(classes, className);
  return (<Tag className={wrapperClasses} {...others}>{!!children && children}</Tag>);
}

export namespace Wrapper {
  export const Centered = toDomElement("wrap", "centered");
  export const StickableBox = stickable.default;
  export const ScrollableList = scrollable.default;
  export const ScrollableListHeader = scrollable.ScrollableHeader;
  export const ScrollableListContent = scrollable.ScrollableContent;
  export const ScrollableListFooter = scrollable.ScrollableFooter;
  export const TwoCol = twoCol.default;
  export const ColText = twoCol.Text;
  export const ColImage = twoCol.Image;
  export const CallToAction = cta.default;
  export const CallToActionContent = cta.CTAContent;
}

export const StickableContext = stickable.StickableContext;
